import { useState }                 from 'react'
import styled                       from 'styled-components/macro'
import { Swiper, SwiperSlide }      from 'swiper/react'
import { Pagination, Keyboard }     from 'swiper'
import { SwiperStyle, SliderStyle } from './MaximizedGallery.Swiper.style'
import { SwiperNav }                from './MaximizedGallery.Navigation'
import { CatchSlide }               from './MaximizedGallery.catch'
import { ImgWrapper } from 'components/ImgContainer/ImgWrapper'
import { TransformComponent, TransformWrapper } from '@pronestor/react-zoom-pan-pinch'

export const Slider = ({initial, images}) => {

  const [ activeIndex, setActiveIndex ] = useState(null)

  const swiper = {
    modules       : [Keyboard], //Pagination, add in array for pagination
    slidesPerView : 1,
    spaceBetween  : 20,
    initialSlide  : initial ?? 0,
    pagination    : { dynamicBullets: true },
    keyboard      : { enabled: true },
    onSlideChange : e => { setActiveIndex( e.activeIndex ) }
  }
  
  return (
    <StyleInjection>
      <Swiper {...swiper}>
        { images?.length > 1 && <SwiperNav activeIndex={activeIndex} {...{images}}/>}
        { 
          images?.map((img, i) => (
            <SwiperSlide style={{ transform: "unset", backfaceVisibility: "unset" ,}} key={i}>
               <TransformWrapper initialScale={1}  minScale={1} limitToBounds={true}  disablePadding={true}>
                <TransformComponent>
                  <ImgWrapper img={img.url} alt='' imgStyle={{ borderRadius: '6px', width: "100%", height: "100%", objectFit: "contain" }} />
                </TransformComponent>
              </TransformWrapper>
              <CatchSlide/>
            </SwiperSlide>
          ))
        }
      </Swiper>
    </StyleInjection>
  )
}

const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  
`
const StyleInjection = styled.div`
  /* ---------------------------------- */
  /*  */ height:100%;  /* <--- Very important  */
  /* ---------------------------------- */
  ${ SwiperStyle }
  ${ SliderStyle }
`